module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/10tn7qc/tc-custom/9780369705945.jpg?1743831880615",
      "alt": "This image is the cover for the book Texan's Inherited Family and A Home for His Family"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Texan's Inherited Family and A Home for His Family\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A ready-made family")]), _c('br'), _c('br'), _c('i', [_vm._v("The Texan's Inherited Family ")]), _vm._v("by Noelle Marchand"), _c('br'), _c('br'), _vm._v(" Busy Texas farmer Quinn Tucker is used to raising crops, not children. So when four nieces and nephews are left in his care, it's not long before he realizes they need a mother. But his search for a wife leads to the least likely woman for illiterate Quinn—schoolmarm Helen McKenna. Could a marriage in name only blossom into something more?"), _c('br'), _c('br'), _c('i', [_vm._v("A Home for His Family")]), _vm._v(" by Jan Drexler"), _c('br'), _c('br'), _vm._v(" Nate Colby came to the Dakota Territory to start over, not to look for a wife. He'll raise his orphaned nieces and nephew without schoolteacher Sarah MacFarland's help. Sarah deserves better than a man who only brings trouble to those around him. Yet helping this ready-made family set up their ranch only makes Sarah long to be a part of it—whatever the risk.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Noelle Marchand, Jan Drexler\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Noelle Marchand's love of literature began as a child and led her to complete her first novel at fifteen. She is a Houston-native who graduated from Houston Baptist University in May 2012 with a bachelors degree in Mass Communication and Speech Communication.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0